import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	dataw: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional()
		.catch(undefined),
});

// Dawna strona szczegolu: szczegol otwiera sie teraz w panelu nad lista, a stare
// linki (np. wyslane mailem) prowadza na liste z otwartym panelem tego dokumentu.
export const Route = createFileRoute("/_auth/dokumenty/leki-przeterminowane_/$idfirm/$iddokf")({
	validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
	beforeLoad: async ({ context, location, params, search }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.dokumenty.leki-przeterminowane",
			location.pathname,
		);
		const valid = /^\d+$/.test(params.idfirm) && /^\d+$/.test(params.iddokf) && search.dataw;
		throw redirect({
			to: "/dokumenty/leki-przeterminowane",
			search: valid ? { dok: `${params.idfirm}_${params.iddokf}_${search.dataw}` } : {},
			replace: true,
		});
	},
});
